import {
  ActionType,
  AppContextType,
  AppState,
  DrugCoverageFilterOption,
  PlanSNPType,
} from "../../../@types";
import {
  createGa4Event,
  Ga4Event,
  Ga4EventType,
} from "../../../helpers/analytics";
import { SearchFilterKeyMapping, SearchFilterKeys } from "./constants";
import { LDFlagSet } from "launchdarkly-js-sdk-common";

export const updateFilter = (
  { state, dispatch }: AppContextType,
  filterName: SearchFilterKeys,
  value: string | string[] | DrugCoverageFilterOption | boolean | undefined
): void => {
  dispatch({
    type: ActionType.UPDATE_SEARCH_RESULTS_FILTERS,
    payload: {
      ...state.searchResultsFilters,
      [filterName]: value,
    },
  });
};

export const searchResultsFilterAnalytics = ({
  state,
  flags,
  text = "",
  filterType,
  filterValue,
}: {
  state: AppState;
  flags: LDFlagSet;
  text?: string;
  filterType: SearchFilterKeys;
  filterValue?: string | boolean;
}) => {
  const filter_name =
    typeof filterValue === "boolean"
      ? filterValue
        ? "true"
        : "false"
      : filterValue;
  createGa4Event({
    event_name: Ga4Event.RESULTS_FILTERED,
    event_type: Ga4EventType.UI_INTERACTION,
    filter_type: SearchFilterKeyMapping[filterType],
    filter_name,
    text,
    state,
    flags,
  });
};

export const updateSNPFilters = (
  { dispatch }: AppContextType,
  snpTypes: string[] | PlanSNPType[]
): void => {
  const hasNotSnp = snpTypes.includes(PlanSNPType.SNP_TYPE_NOT_SNP);
  if (snpTypes.length && !hasNotSnp) {
    // the snp filters are additive, so if any exist, we need to also send SNP_TYPE_NOT_SNP to the API
    snpTypes.push(PlanSNPType.SNP_TYPE_NOT_SNP);
  } else if (snpTypes.length === 1 && hasNotSnp) {
    snpTypes = [];
  }
  dispatch({
    type: ActionType.UPDATE_SNP_FILTERS,
    payload: snpTypes,
  });
};
